const isIntentSubscribe = (obj) => {
  return !!obj && typeof obj.intentSubscribe === "function";
};
export {
  isIntentSubscribe
};
//# sourceMappingURL=IntentSubscribe.js.map
